/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getNetwork, setting } from 'loraactions/tdm';

const propTypes = {
  children: React.PropTypes.node.isRequired,
  getNetwork: PropTypes.func.isRequired,
  getTypesJSON: PropTypes.func.isRequired,
};

class TDMView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getNetwork();
    this.props.getTypesJSON();
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

TDMView.propTypes = propTypes;

const mapDispatchToProps = ({
  getTypesJSON: setting,
  getNetwork,
});

export default connect(null, mapDispatchToProps)(TDMView);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/index.jsx